<template>
    <div id="home" class="page-alternate">
        <div class="container">
            <h3 style="color: aliceblue; margin-top:10px" class="spec">Mis Datos</h3>
            <div class="" wfd-id="558" bis_skin_checked="1">
                <!-- Start Accordion -->
                <div class="accordion accordion-flush" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                DATOS PERSONALES
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="accordion-inner" bis_skin_checked="1">
                                    Nombre: {{user.user_data.data.user_name}}<br>
                                    <!-- Apellido: {{user}}<br> -->
                                    Balance: {{user.user_data.data.balance}}<br>
                                    Correo: {{user.user_data.data.email}} <br>
                                    Ultimo Ingreso: {{formatearFecha(auditoria.fecha)}}<br>
                                    Direccion IP: {{auditoria.ip}}<br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                CAMBIAR CONTRASEÑA
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <span v-if="showChangePassword">Para preversar la seguridad de su cuenta, le aconsejamos cambiar su contraseña.</span>
                                <form @submit.prevent="changePassword()" class="">                              
                                    Recuerde ingresar una clave robusta incluyendo mayusculas, minusculas y numeros.  con mas de 6 caracteres.
                                <div class="pb-2 font-size-custom mb-3 my-3">
                                    <label style="color:white" for="passwordJm">Ingrese su actual contraseña</label>
                                    <i class="fas fa-eye prefix change-password-reveal white-text mx-2" @click="show_hide_Password('passwordJm')"></i>
                                        <input type="password" placeholder="Clave Actual" class="login-user-control" autocomplete="off" required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-3 my-3">
                                    <label style="color:white" for="passwordJm">Ingrese su nueva contraseña</label>
                                    <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2" @click="show_hide_Password('passwordJm')"></i>
                                        <input v-model="password" id="passwordJm" type="password" placeholder="Nueva Clave" class="login-user-control" autocomplete="off" required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-3 my-3">
                                    <label style="color:white" for="passwordJm2">Repita su nueva contraseña</label>
                                    <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2" @click="show_hide_Password('passwordJm2')"></i>
                                        <input v-model="password2" id="passwordJm2" type="password" placeholder="Repetir Clave" class="login-user-control" maxlength="16" autocomplete="off" required>
                                    </div>
                                    
                                    <div class="d-grid gap-2">
                                        <button type="submit" class="btn btn-primary" :style="{backgroundColor: skin.main_modal_background, color: skin.main_modal_text}" :disabled="login_inProcess">MODIFICAR</button>
                                    </div>
                                </form>
                                <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                REPORTES
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <strong>
                                    En esta seccion encontrará reportes y transacciones 
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Accordion -->
            </div>
        </div>   
    </div>
    
</template>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300&display=swap');
.page-alternate {
    background: url(https://resources.jbets.online/odin/fondo1.png) no-repeat fixed;
    background-size: cover;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
}

.container {
    background-color: transparent; /* Fondo semi-transparente */
    padding: 20px;
    border-radius: 10px;
    max-width: 1250px;
    width: 100%;
    margin-top: 10px;
}

.span12 {
    width: 80%;
    padding: 0px;
    border-radius: none; /* Ajusta el borde */
    font-family: 'Titillium Web', sans-serif;
}

.accordion .accordion-body {
    background-color: #555555; /* Ajusta el color de fondo del acordeón */
    color: white; /* Ajusta el color del texto */
    font-size: 16px;
    font-family: 'Titillium Web', sans-serif;}

.accordion-header .accordion-button {
    background-color: #DE5E60; /* Ajusta el color del botón del acordeón */
    color: white;font-size: 20px;
    font-family: 'Titillium Web', sans-serif;
    font-weight: bold;
}
.accordion-header .accordion-button.collapsed {
    background-color: #333333; /* Ajusta el color del botón colapsado del acordeón */
    color: rgb(7, 7, 7);
}

.form-group {
    margin-bottom: 1rem;
}

.form-group label {
    color: white;
}

.form-group i {
    cursor: pointer;
}

.btn-primary, .btn-secondary {
    font-size: medium;
    font-weight: bold;
    padding: 10px;
    margin: 5px;
    width: 200px;
}

@media (max-width: 768px) {
    .container {
        padding: 10px;
        margin: 2px;
        background-color: transparent;
    }

    .span12 {
        padding: 0;
        border-radius: none;
    }

    .btn-primary, .btn-secondary {
        width: 100%;
    }
    
}
</style>


<script>
import axios from 'axios';
export default {
    name: "misDatos",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            password: "",
            password2: "",
            show1: true,
            show2: true,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    computed: {
        showChangePassword(){
            return this.$store.getters['getShowChangePassword'];
        },
        auditoria(){
            return this.$store.getters['getAuditoria'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        showChangePassword() {
            return this.$store.getters['getShowChangePassword'];
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
    },
    methods: {
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
        async changePassword() {
            try {
                this.login_inProcess = true;
                let data = await axios.post(this.apiUrlnew+ "cambiar_password",
                    {
                        "users": [this.user.user_data.data.user_id ?? this.user.user_data.data.id],
                        "password": this.password,
                        "password1": this.password2,
                        "token": this.user.token,
                        "login_id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                        "site": this.site
                    })
                if (data.data.error) {
                    this.status.message = data.data.error;
                    this.status.type = "danger";
                }
                else {
                    this.status.message = data.data.message;
                    this.status.type = "success";
                    this.logout();
                    setTimeout(() => {
                        // document.getElementById("closeChangePassword").click();
                    }, 2000)
                }
                this.login_inProcess = false;
                // this.$store.dispatch('logOut');
                this.$store.dispatch("setMisdatos", false);
                this.$root.$emit('forceRender');
            } catch (error) {
                this.status.message = error.response.data.error;
                this.status.type = "danger";
                this.login_inProcess = false;
            }

        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        show_hide_Password(target) {
            if (target == "password") {
                document.getElementById(target).type = this.show1 ? "text" : "password";
                this.show1 = !this.show1;
            }
            else {
                document.getElementById(target).type = this.show2 ? "text" : "password";
                this.show2 = !this.show2;
            }
        },
    }
}
</script>